export const User = {
    SET_USER: 'SET_USER'
}
export function setUser(user) {
    return {type: User.SET_USER, user}
}
